<template>
  <div class="md-layout md-alignment-center-center callback-container">
    <h3>Your email was verified, redirecting you soon...</h3>
    <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
  </div>
</template>

<script>
import auth from "../../../lib/common/providers/auth";

export default {
  name: "Callback",
  async mounted() {
    setTimeout(() => {
        this.$router.push('login');
    }, 1500);
  }
};
</script>

<style>
.callback-container {
  flex-direction: column;
}
</style>
